
<div>
  @if (combinedEnabled) {
    <mat-tab-group [(selectedIndex)]="selectedTab">
      <mat-tab label="Reports">
        <reports-combined [canSend]="enableGenerateReports" (showHistory)="openHistory($event)"></reports-combined>
      </mat-tab>
      <mat-tab label="History">
        <reports-sent #history></reports-sent>
      </mat-tab>
    </mat-tab-group>
  } @else {
    <mat-tab-group>
      <mat-tab label="View Reports">
        <reports-view></reports-view>
      </mat-tab>
      <mat-tab label="Sent Reports">
        <reports-sent></reports-sent>
      </mat-tab>
      @if (enableGenerateReports) {
        <mat-tab label="Generate Reports">
          <reports-generate></reports-generate>
        </mat-tab>
      }
    </mat-tab-group>
  }
</div>